export interface VendorConfig {
  vendor: PossibleVendors | null;
  configuration?: IndividualVendorConfig;
}

export enum PossibleVendors {
  INT1 = 'INT-1',
  INT2 = 'INT-2',

  // For now, these are placeholders that will correlate to the domestic vendors
  US1 = 'US-1',
  US2 = 'US-2',
  US3 = 'US-3',
  US4 = 'US-4',
  US5 = 'US-5',
  INT2X21 = 'INT-2+2-1',
  INT2X22 = 'INT-2+2-2',
}

export type IndividualVendorConfig = InternationalOneConfig | InternationalTwoPlusTwoOneConfig[];

export interface InternationalOneConfig {
  'data-sources': string[];
}

export enum TwoPlusTwoAccounts {
  ACCOUNT1 = 'account_1',
}

export interface InternationalTwoPlusTwoOneConfig {
  'data-source': string;
  'account-name': TwoPlusTwoAccounts;
}
